<template>
  <b-nav :hidden="!isAdminStatus">
    <b-nav-item-dropdown
        id="my-nav-dropdown "
        text="Troubleshooting"
        toggle-class="nav-link-custom"
    >
      <template slot="button-content">
        <i class="fa mr-2 fa-tools text-indigo" font-scale="1"></i>
        <span>Troubleshooting</span>
      </template>

      <slot v-for="(item, index) in troubleLinks" name="title">
        <b-dropdown-item :to="item.url">
          <i :class="`${item.icon} text-${item.color} pr-2`"></i>
          {{ item.label }}
        </b-dropdown-item>
      </slot>

      <!-- <b-dropdown-item to="/graphing">
        <i class="fa fa-cogs text-" font-scale="1"></i>
        Diameter Usage Graphing
      </b-dropdown-item>
      <b-dropdown-item to="/enum">
        <i class="fa fa-cogs text-" font-scale="1"></i>
        ENUM Status
      </b-dropdown-item>
      <b-dropdown-item to="/ims_kpi_graphing">
        <i class="fa fa-cogs text-" font-scale="1"></i>
        IMS KIP Graphing
      </b-dropdown-item>
      <b-dropdown-item to="/ims_subscriber_status">
        <i class="fa fa-cogs text-" font-scale="1"></i>
        IMS Subscriber Status
      </b-dropdown-item>
      <b-dropdown-item to="/aaa_log_download">
        <i class="fa fa-cogs text-" font-scale="1"></i>
        Log Download AAA
      </b-dropdown-item>
      <b-dropdown-item to="/sms_router_logs">
        <i class="fa fa-cogs text-" font-scale="1"></i>
        SMS Router Logs
      </b-dropdown-item>
      <b-dropdown-item to="/aaa_log_search">
        <i class="fa fa-cogs text-" font-scale="1"></i>
        Log Search AAA
      </b-dropdown-item>
      <b-dropdown-item to="/broadband_graphs">
        <i class="fa fa-cogs text-" font-scale="1"></i>
        OTZ Broadband Graphs
      </b-dropdown-item>
      <b-dropdown-item to="/roaming_heatmap">
        <i class="fa fa-cogs text-" font-scale="1"></i>
        OTZ Roaming Heatmap
      </b-dropdown-item>
      <b-dropdown-item to="/overwatch">
        <i class="fa fa-cogs text-" font-scale="1"></i>
        Overwatch
      </b-dropdown-item>
      <b-dropdown-item to="/sms_mt_queue">
        <i class="fa fa-cogs text" font-scale="1"></i>
        SMS MT Queue
      </b-dropdown-item>
      <b-dropdown-item to="/sms_subscriber_tracing">
        <i class="fa fa-cogs text-" font-scale="1"></i>
        SMS Subscriber Tracing
      </b-dropdown-item>
      <b-dropdown-item to="/serviceassurance">
        <i class="fa fa-cogs text-" font-scale="1"></i>
        Service Assurance
      </b-dropdown-item> -->
    </b-nav-item-dropdown>
  </b-nav>
</template>
<script>
import initService from '../../../common/api-services/init-service';
import configDirective from '../../../common/directive/config-directive';

export default {
  name: 'top-trouble-custom-group',
  components: {},
  data() {
    return {
      isAdminStatus: false,
      groups: [],
      troubleLinks: [],
      troubleCollaps: false,
    }
  },
  mounted() {
    this.troubleLinks = configDirective.getTroubleLinks();
    //console.log('trouble:', this.troubleLinks);
    this.isAdminStatus = initService.getAdministratorRole() || initService.getPortalAdminRole();
  },
}
</script>
